var site;

site = site || {};

(function ($) {
  Drupal.behaviors.segmentedDragBarV1 = {
    $document: $(document),
    $window: $(window),
    $modules: [],
    isRTL: site.direction.isRTL,
    pageLoad: false,
    isMobile: false,
    mobileBreak: 1024,
    attach: function (context) {
      var self = this;
      var $modules = $('.js-segmented-dragbar', context);

      self.isMobile = window.innerWidth <= self.mobileBreak;
      $modules.each(function () {
        var $module = $(this);

        self.getDom($module);
        self.setConfig($module);
        self.setInits($module);
        self.setListeners($module);
        self.$modules.push($module);
      });

      self.$window.off('resize.segSlider').on(
        'resize.segSlider',
        _.debounce(function () {
          self.isMobile = window.innerWidth <= self.mobileBreak;
          if (self.pageLoad) {
            self.$modules.forEach(function ($mod) {
              self.setConfig($mod);
              self.setInits($mod);
            });
          } else {
            self.pageLoad = true;
          }
        }, 100)
      );
    },
    getDom: function ($module) {
      $module.nodes = {};
      $module.nodes.backgrounds = $(
        '.js-segmented-dragbar-background',
        $module
      );
      $module.nodes.container = $('.js-segmented-dragbar-container', $module);
      $module.nodes.dragElement = $('.js-segmented-dragbar-handle', $module);
      $module.nodes.dragElementImg = $(
        '.js-segmented-dragbar-handleimg',
        $module
      );
    },
    setConfig: function ($module) {
      $module.props = {};
      $module.state = {};
      $module.props.segmentCount =
        parseInt($module.data('segmentCount'), 10) || 5;
      $module.props.draggerWidth = $module.nodes.dragElement.outerWidth();
      $module.props.draggerImgWidth =
        $module.nodes.dragElementImg.outerWidth() / 2;
      $module.props.containerOffset = $module.nodes.container.offset().left;
      $module.props.containerWidth = $module.nodes.container.outerWidth();
      $module.props.draggerOffset = $module.nodes.dragElement.offset().left;
      $module.props.desktopHandleSrc =
        $module.nodes.dragElementImg.data('dtSrc');
      $module.props.mobileHandleSrc =
        $module.nodes.dragElementImg.data('mobileSrc');
      $module.props.segmentWidth =
        $module.props.containerWidth / $module.props.segmentCount;
      $module.props.minLeft = $module.props.containerOffset;
      $module.props.maxLeft =
        $module.props.containerOffset +
        $module.props.containerWidth -
        $module.props.draggerImgWidth;
      $module.props.restingSegment;
      $module.props.segments = [];
      $module.state.dragging = false;
      $module.state.leave = false;
    },
    setInits: function ($module) {
      var self = this;
      var i;
      var $background;
      var handleSource = self.isMobile
        ? $module.props.mobileHandleSrc
        : $module.props.desktopHandleSrc;

      $module.nodes.backgrounds.each(function (index) {
        $background = $(this);
        if (index === 0) {
          $background.addClass('first-background');
        }
        if (index === 2) {
          $background.addClass('show-background');
        }
        $module.attr(
          'data-background-' + index,
          $background.find('img').attr('src')
        );
      });

      for (i = 0; i < $module.props.segmentCount; i++) {
        $module.props.segments.push($module.props.segmentWidth * i);
      }
      $module.nodes.dragElementImg.attr('src', handleSource);

      if (self.isMobile) {
        setTimeout(function () {
          // Update the mobile middle background image on page load.
          if ($module.nodes.backgrounds.length >= 2) {
            self.segmentImageUpdate($module, $module.data('background-2'));
          }
        }, 100);
      }
    },
    getRTLPosition: function (position) {
      var self = this;
      var startingPoint = self.isRTL ? 100 : 0;
      var dirMult = self.isRTL ? -1 : 1;

      return startingPoint + position * dirMult;
    },
    setActive: function ($module, active) {
      $module.state.dragging = active;
      if (active) {
        $module.nodes.dragElement.addClass('draggable');
      } else {
        $module.nodes.dragElement.removeClass('draggable');
      }
    },
    setListeners: function ($module) {
      var self = this;
      var xPosition;

      $module.nodes.dragElement
        .on('mousedown vmousedown', function (e) {
          self.setActive($module, true);
          xPosition =
            $module.nodes.dragElement.offset().left +
            $module.props.draggerWidth -
            e.pageX;
          e.preventDefault();
        })
        .on('mouseup vmouseup', function () {
          self.setActive($module, false);
          self.segmentFire($module);
        });

      $module.nodes.container
        .on('mousemove vmousemove', function (evt) {
          if ($module.state.dragging) {
            !window.requestAnimationFrame
              ? setTimeout(function () {
                self.onDragSlider(evt, xPosition, $module);
              }, 100)
              : requestAnimationFrame(function () {
                self.onDragSlider(evt, xPosition, $module);
              });
          }
        })
        .on('mouseleave', function () {
          $module.state.leave = true;
        })
        .on('mouseup touchend', function () {
          self.setActive($module, false);
        })
        .on('mouseenter', function () {
          $module.state.leave = false;
        });

      self.$window.on('mouseup', function () {
        if ($module.state.leave) {
          self.setActive($module, false);
        }
      });
      $(document).on(
        'fragrance_finder_formatter:start_over',
        function (e) {
          var $fragranceFinder = e.payload['$el'];
          var $currentSegmentedBar = $fragranceFinder.find(
            '.js-segmented-dragbar'
          );
          var perc;

          self.isMobile ? (perc = '53%') : (perc = '55.5%');

          if ($currentSegmentedBar.length > 0) {
            $('.js-segmented-dragbar-handle', $currentSegmentedBar).css(
              'left',
              perc
            );
          }
        }
      );
    },
    segmentImageUpdate: function ($module, backgroundUrl) {
      $.event.trigger({
        type: 'segmented_drag_bar:update_image',
        payload: {
          $el: $module,
          backgroundUrl: backgroundUrl
        }
      });
    },
    segmentFire: function ($module) {
      $.event.trigger({
        type: 'segmented_drag_bar:segment_to_trigger',
        payload: {
          $el: $module,
          segment: $module.props.restingSegment
        }
      });
    },
    segmentCheck: function ($module, pageX) {
      var self = this;
      var i;
      var dist = pageX - $module.props.containerOffset;
      var segment;
      var segmentToTrigger = 0;
      var backgroundCount = $module.nodes.backgrounds.length;
      var $background;

      for (i = $module.props.segments.length - 1; i >= 0; i--) {
        segment = $module.props.segments[i];
        if (Number(dist) >= Number(segment)) {
          segmentToTrigger = i;
          break;
        }
      }
      $module.props.restingSegment = segmentToTrigger;
      if ((backgroundCount > 0) & (segmentToTrigger < backgroundCount)) {
        $background = $($module.nodes.backgrounds[segmentToTrigger]);
        $module.nodes.backgrounds.removeClass('show-background');
        $background.addClass('show-background');
      }
      if (self.isMobile) {
        self.segmentImageUpdate(
          $module,
          $module.data('background-' + segmentToTrigger)
        );
      }
    },
    onDragSlider: function (e, xPosition, $module) {
      var self = this;
      var pageX = e.pageX;
      var leftValue = pageX + xPosition - $module.props.draggerImgWidth;
      var widthValue;

      if ($module.props.containerOffset === 0) {
        $module.props.containerOffset = $module.nodes.container.offset().left;
        $module.props.minLeft = $module.props.containerOffset;
        $module.props.maxLeft =
          $module.props.containerOffset +
          $module.props.containerWidth -
          $module.props.draggerImgWidth;
      }

      if (leftValue < $module.props.minLeft) {
        self.isMobile
          ? (widthValue = 'calc(0% + 45px)')
          : (widthValue = 'calc(0% + 35px)');
      } else if (leftValue > $module.props.maxLeft) {
        self.isMobile
          ? (widthValue = '100%')
          : (widthValue = 'calc(100% + 19px)');
      } else {
        widthValue =
          ((leftValue +
            $module.props.draggerImgWidth -
            $module.props.containerOffset) *
            100) /
          $module.props.containerWidth;
        widthValue = widthValue + '%';
      }

      // RTL not required here. This 'left' value follows user's mouse movements.
      $('.draggable', $module)
        .css('left', widthValue)
        .on('mouseup vmouseup', function () {
          $(this).removeClass('draggable');
        });

      self.segmentCheck($module, e.pageX);
    }
  };
})(jQuery);
